import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AgGridReact } from 'ag-grid-react';
import { connect } from 'react-redux';
import {
  reduce, map, indexOf, isArray, isNumber,
  delay, isBoolean, trim, uniq, startsWith,
} from 'lodash';
import moment from 'moment';
import { Button, Tooltip, OverlayTrigger } from 'react-bootstrap';
import Fa from 'react-fontawesome';
import ReactResizeDetector from 'react-resize-detector';
import {
  saveState, saveCustomMetaData,
  deleteCustomMetaData,
  requestEditColumn,
  requestDeleteColumn,
  requestResetColumns,
} from './actions';
import CustomHeader from './header';
import {
  getTableStates,
  getColumnData,
} from './reducer';
import {
  getViewableDimensions, getWindowWidth,
  getWindowHeight, getHeaderHeight, getFooterHeight,
} from '../../modules/App/AppReducer';
import {
  updateTablePreferenceColumn,
  updateTablePreferenceColumnPositions,
} from '../../modules/App/AppActions';
import CustomFieldRenderer from '../table-cells/CustomFieldRenderer';
import CustomMetaFieldRenderer from '../table-cells/CustomMetaFieldRenderer';
import RequestedFeedbackRenderer from '../table-cells/RequestedFeedbackRenderer';
import CheckboxCellEditor from './checkbox';
import DateCellEditor from './date-cell-editor';
import SearchField from '../search-field';
import StatusRowComponent from './total-stats';
import ColumnDataManager from './column-data-manager';
import { getUser, getUserCurrentOrganization } from '../../modules/Auth/AuthReducer';
import Veil from './veil';
import DeleteColumnModal from './delete-column-modal';
import ResetColumnsModal from './reset-columns-modal';
import EditColumnModal from './edit-column-modal';
import AddColumnButton from './add-column-button';

export const CUSTOM_FIELD_TYPES = {
  OPPORTUNITY: 'OPPORTUNITY',
  ACCOUNT: 'ACCOUNT',
  USER: 'USER',
};

const internalColId = 'ag-Grid-AutoColumn';

export function getCellDataDetail(targetObject, customFieldType, data) {
  let targetId = null;
  let ids = [];
  if (customFieldType === CUSTOM_FIELD_TYPES.OPPORTUNITY) {
    if (targetObject === 'OpportunityCompetitor') {
      targetId = 'competitors';
    } else if (targetObject === 'Account') {
      targetId = 'account_id';
    } else if (targetObject === 'Product') {
      targetId = 'line_items';
    } else if (targetObject === 'User') {
      targetId = 'owner_id';
    } else if (targetObject === 'Opportunity') {
      targetId = 'opportunity_id';
    } else if (targetObject === 'Contact') {
      targetId = 'contact_roles';
    }
    if (targetId === 'competitors') {
      ids = map(data[targetId], 'id');
    } else if (targetId === 'line_items') {
      ids = map(data[targetId], 'product_id');
    } else if (targetId === 'contact_roles') {
      ids = map(data[targetId], 'contact_id');
    } else if (targetId !== null) {
      const hasId = data[targetId] !== undefined && data[targetId] !== null;
      ids = hasId ? [data[targetId]] : [];
    }
  } else if (customFieldType === CUSTOM_FIELD_TYPES.ACCOUNT) {
    if (targetObject === 'Account') {
      targetId = 'account_id';
    } else if (targetObject === 'User') {
      targetId = 'owner_id';
    }
    if (targetId !== null) {
      const hasId = data[targetId] !== undefined && data[targetId] !== null;
      ids = hasId ? [data[targetId]] : [];
    }
  } else if (customFieldType === CUSTOM_FIELD_TYPES.USER) {
    if (targetObject === 'User') {
      targetId = 'owner_id';
    }
    if (targetId !== null) {
      const hasId = data[targetId] !== undefined && data[targetId] !== null;
      ids = hasId ? [data[targetId]] : [];
    }
  }
  return { targetId, ids };
}


class GodTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ready: false,
      fullScreenMode: props.fullScreenMode,
      navHeight: 0,
      topControlHeight: 0,
      groupIncludeFooter: true,
      groupIncludeTotalFooter: true,
      isGrouping: false,
      totalRows: 0,
    };
    this.onGridReady = this.onGridReady.bind(this);
    this.onColumnVisible = this.onColumnVisible.bind(this);
    this.onColumnResized = this.onColumnResized.bind(this);
    this.onColumnMoved = this.onColumnMoved.bind(this);
    this.refreshAggregate = this.refreshAggregate.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.toggleFullScreen = this.toggleFullScreen.bind(this);
    this.onResizeContainer = this.onResizeContainer.bind(this);
    this.getMainMenuItems = this.getMainMenuItems.bind(this);
    this.updateColumnAutoHeight = this.updateColumnAutoHeight.bind(this);
    this.setGroupIncludeFooter = this.setGroupIncludeFooter.bind(this);
    this.setGroupIncludeTotalFooter = this.setGroupIncludeTotalFooter.bind(this);
    this.onColumnRowGroupChanged = this.onColumnRowGroupChanged.bind(this);
    this.handleColumnDataLoaded = this.handleColumnDataLoaded.bind(this);
    this.columnValueGetter = this.columnValueGetter.bind(this);
    this.columnCheckEditable = this.columnCheckEditable.bind(this);
    this.columnValueParser = this.columnValueParser.bind(this);
    this.columnValueSetter = this.columnValueSetter.bind(this);
    this.columnCellRendererSelector = this.columnCellRendererSelector.bind(this);
    this.columnDateKeyCreator = this.columnDateKeyCreator.bind(this);
    this.columnValueFormatter = this.columnValueFormatter.bind(this);
    this.columnBoolKeyCreator = this.columnBoolKeyCreator.bind(this);
    this.columnPicklistKeyCreator = this.columnPicklistKeyCreator.bind(this);
    this.handleDownload = this.handleDownload.bind(this);
    this.getContextMenuItems = this.getContextMenuItems.bind(this);
    this.onResizeTopController = this.onResizeTopController.bind(this);
    this.getAllRowData = this.getAllRowData.bind(this);
    this.statusBar = null;
  }

  componentWillMount() {
    const { id } = this.props;
    const { userPreferences } = this.context;
    const groupIncludeFooter = userPreferences[`${id}-group-include-footer`] !== undefined ? userPreferences[`${id}-group-include-footer`] : true;
    const groupIncludeTotalFooter = userPreferences[`${id}-group-include-total-footer`] !== undefined ? userPreferences[`${id}-group-include-total-footer`] : true;
    this.setState({
      groupIncludeFooter, groupIncludeTotalFooter,
    });
  }

  componentWillUnmount() {
    this.saveTableStates();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.fullScreenMode !== nextProps.fullScreenMode) {
      this.setState({ fullScreenMode: nextProps.fullScreenMode });
    }
  }

  onResizeTopController(w, topControlHeight) {
    this.setState({ topControlHeight });
  }

  onColumnVisible(params) {
    const { source, columns } = params; // source = api | columnMenu,
    if (source === 'toolPanelUi' && columns.length > 0) {
      const saveParams = reduce(columns, (items, column) => {
        items.push({
          _id: column.colId,
          is_visible: column.visible,
          width: column.actualWidth,
        });
        return items;
      }, []);
      // const showing = this.gridApi.getOpenedToolPanel();
      this.saveColumns(saveParams)
        .then(() => {
          // if (showing) {
            // this.gridApi.openToolPanel(showing);
          // }
          this.props.onColumnVisible(params);
        });
    } else {
      this.props.onColumnVisible(params);
    }

  }

  onColumnResized(params) {
    const { source, finished, columns } = params; // source = api | uiColumnDragged; finished = true | false
    if (finished && source === 'uiColumnResized' && columns.length > 0) {
      const saveParams = reduce(columns, (items, column) => {
        if (column.colId !== internalColId && !startsWith(column.colId, '__')) {
          items.push({
            _id: column.colId,
            is_visible: column.visible,
            width: column.actualWidth,
          });
        }
        return items;
      }, []);
      if (saveParams.length) {
        this.saveColumns(saveParams)
          .then(() => {
            this.gridApi.resetRowHeights();
            this.props.onColumnResized(params);
          });
      }
    } else {
      this.props.onColumnResized(params);
    }
  }

  onColumnMoved(params) {
    const { id } = this.props;
    const { source, columns, finished } = params; // source = api | uiColumnDragged; toIndex = new Index
    if (finished && source === 'uiColumnMoved' && columns.length > 0 && this.gridColumnApi) {
      const cols = this.gridColumnApi.getColumnState();
      const newColumnOrder = reduce(cols, (items, col) => {
        if (col.colId !== internalColId && !startsWith(col.colId, '__')) {
          items.push(col.colId);
        }
        return items;
      }, []);
      this.saveTableStates(() => {
        this.props.dispatch(updateTablePreferenceColumnPositions(id, newColumnOrder))
        .then(() => {
          this.restoreTableStates();
          this.props.onColumnMoved(params);
        });
      });
    }
  }

  onColumnRowGroupChanged(params) {
    const { column } = params;
    const { isGrouping } = this.state;
    const newValue = column !== null && column !== undefined;
    this.setState({ isGrouping: newValue }, () => {
      if (isGrouping !== newValue) {
        this.refreshAggregate();
      }
    });
    this.props.onColumnRowGroupChanged(params);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.restoreTableStates();
    this.setState({ ready: true }, () => {
      this.props.onGridReady(params);
    });
    delay(() => {
      this.gridApi.resetRowHeights();
    }, 100);
  }

  restoreTableStates() {
    const { tableState } = this.props;
    if (tableState && this.gridApi) {
      // this.gridApi.setSortModel(tableState.sortState);
      this.gridApi.setFilterModel(tableState.filterState);
    }
    if (tableState && this.gridColumnApi) {
      this.gridColumnApi.applyColumnState(tableState.columnState);
      this.gridColumnApi.setColumnGroupState(tableState.groupState);
    }
  }

  refreshColumnFilters() {
    this.restoreTableStates();
  }

  onResizeContainer(width, navHeight) {
    this.setState({ navHeight });
  }

  setGroupIncludeFooter(groupIncludeFooter) {
    const { id } = this.props;
    this.setState({ groupIncludeFooter }, () => {
      this.refreshAggregate();
    });
    this.context.updateUserPreference(`${id}-group-include-footer`, groupIncludeFooter);
  }

  setGroupIncludeTotalFooter(groupIncludeTotalFooter) {
    const { id } = this.props;
    this.setState({ groupIncludeTotalFooter }, () => {
      this.refreshAggregate();
    });
    this.context.updateUserPreference(`${id}-group-include-total-footer`, groupIncludeTotalFooter);
  }

  getMainMenuItems(params) {
    if (this.props.getMainMenuItems) {
      params.defaultItems = this.props.getMainMenuItems(params);
    }

    // remove the default resetColumns
    // it's confusing, we will build our own reset columns actions
    params.defaultItems = map(params.defaultItems, (item) => {
      if (item === 'resetColumns') {
        return {
          name: 'Reset All Columns',
          icon: '<i class="fa fa-refresh"></i>',
          action: () => {
            this.requestResetColumns();
          },
        };
      }
      return item;
    }, []);

    const columnId = params.column.getId();
    if (columnId !== 'ag-Grid-AutoColumn') {
      const { column } = params;
      if (column && column.colDef && column.colDef.cellRendererParams) {
        const tsColumn = column.colDef.cellRendererParams.column;
        const menuItems = params.defaultItems.slice(0);
        if (column.colDef.cellRendererParams.enableAutoHeight) {
          menuItems.push('separator');
          const subMenus = [
            { name: 'Fixed', value: false },
            { name: 'Auto ', value: true },
          ];
          menuItems.push({
            name: `Row Height: ${tsColumn.auto_height ? 'Auto' : 'Fixed'}`,
            checked: tsColumn.auto_height,
            subMenu: subMenus.map(item => ({
              ...item,
              checked: item.value === tsColumn.auto_height,
              action: () => {
                this.updateColumnAutoHeight(columnId, item.value);
              },
            })),
          });
        }
        if (column.colDef.cellRendererParams.column) {
          const tsColumn = column.colDef.cellRendererParams.column;
          if (tsColumn.is_system === false) {
            menuItems.push('separator');
            menuItems.push({
              name: 'Edit Column',
              icon: '<i class="fa fa-edit"></i>',
              action: () => {
                this.requestEditColumn(tsColumn);
              },
            });
            menuItems.push({
              name: 'Delete Column',
              icon: '<i class="fa fa-trash"></i>',
              action: () => {
                this.requestDeleteColumn(tsColumn);
              },
            });
          }
        }
        return menuItems;
      }
    } else {
      return this.addGroupIncludeFooterMenu(params);
    }

    return params.defaultItems;
  }

  getContextMenuItems(/* params */) {
    const results = [
      'copy',
      'copyWithHeaders',
    ];
    return results;
  }

  addGroupIncludeFooterMenu(params) {
    const { groupIncludeFooter, groupIncludeTotalFooter } = this.state;
    const menuItems = params.defaultItems.slice(0);
    const subMenus = [
      { name: 'On', value: true },
      { name: 'Off', value: false },
    ];
    menuItems.push('separator');
    menuItems.push({
      name: `Grouped totals: ${groupIncludeFooter ? 'On' : 'Off'}`,
      checked: groupIncludeFooter,
      subMenu: subMenus.map(item => ({
        ...item,
        checked: item.value === groupIncludeFooter,
        action: () => {
          this.setGroupIncludeFooter(item.value);
        },
      })),
    });
    menuItems.push({
      name: `Grand total row: ${groupIncludeTotalFooter ? 'On' : 'Off'}`,
      checked: groupIncludeTotalFooter,
      subMenu: subMenus.map(item => ({
        ...item,
        checked: item.value === groupIncludeTotalFooter,
        action: () => {
          this.setGroupIncludeTotalFooter(item.value);
        },
      })),
    });
    return menuItems;
  }

  updateColumnAutoHeight(columnId, autoHeight) {
    const { id } = this.props;
    this.saveTableStates(() => {
      const p = this.props.dispatch(updateTablePreferenceColumn(id, columnId, { auto_height: autoHeight }));
      p.then(() => {
        this.restoreTableStates();
        if (this.gridApi) {
          this.gridApi.resetRowHeights();
        }
      });
    });
  }

  saveTableStates(cb = () => {}) {
    if (this.gridApi) {
      const { auth, organization } = this.props;
      const columnState = this.gridColumnApi.getColumnState();
      const groupState = this.gridColumnApi.getColumnGroupState();
      // console.clear();
      // console.log('this.gridColumnApi.getSortModel()', this.gridApi);

      // const sortState = this.gridApi.getSortModel();
      const filterState = this.gridApi.getFilterModel();
      this.props.dispatch(saveState(organization ? organization._id : null, auth ? auth._id : null, this.props.id, {
        columnState,
        groupState,
        // sortState,
        filterState,
      }))
        .then(cb);
    }
  }

  toggleFullScreen() {
    const { fullScreenMode } = this.state;
    this.saveTableStates(() => {
      this.setState({ fullScreenMode: !fullScreenMode });
      if (fullScreenMode) {
        this.props.onExitFullScreen();
      } else {
        this.props.onEnterFullScreen();
      }
    });
  }

  refreshAggregate() {
    if (this.gridApi) {
      this.gridApi.refreshClientSideRowModel('aggregate');
    }
  }

  requestEditColumn(column) {
    const { id } = this.props;
    this.props.dispatch(requestEditColumn(id, column));
  }

  requestDeleteColumn(column) {
    const { id } = this.props;
    this.props.dispatch(requestDeleteColumn(id, column));
  }

  requestResetColumns() {
    const { id } = this.props;
    this.props.dispatch(requestResetColumns(id));
  }

  handleColumnDataLoaded(coldIds) {
    if (this.gridApi) {
      this.gridApi.refreshCells({ force: true, columns: [...coldIds, 'ag-Grid-AutoColumn'] });
      this.refreshAggregate();
    }
  }

  columnValueSetter(params) {
    const { data, newValue, colDef: { cellRendererParams } } = params;
    const { column, customFieldType, isCustomMeta } = cellRendererParams;
    if (isCustomMeta) {
      const doneCB = () => {
        this.handleColumnDataLoaded([column._id]);
        if (indexOf(['picklist', 'string'], column.type) >= 0 && column.auto_height) {
          this.gridApi.resetRowHeights();
        }
      };
      let keyField = null;
      if (customFieldType === CUSTOM_FIELD_TYPES.OPPORTUNITY) {
        keyField = 'opportunity_id';
      } else if (customFieldType === CUSTOM_FIELD_TYPES.ACCOUNT) {
        keyField = 'account_id';
      } else if (customFieldType === CUSTOM_FIELD_TYPES.USER) {
        keyField = 'user_id';
      }
      if (!keyField) {
        return false;
      }
      const id = data[keyField];

      if (id) {
        if (newValue === '' ||
          newValue === null ||
          newValue === undefined ||
          (isArray(newValue) && newValue.length === 0)
        ) {
          this.props.dispatch(deleteCustomMetaData(column.target_custom_meta_id, id, column._id))
            .then(doneCB);
        } else {
          this.props.dispatch(saveCustomMetaData(column.target_custom_meta_id, id, params.newValue, column._id))
            .then(doneCB);
        }
        return true;
      }
    }
    return false;
  }

  columnValueParser(params) {
    const { newValue, colDef: { refData, cellRendererParams } } = params;
    const { column, customFieldType } = cellRendererParams;
    const { type } = column;
    if (customFieldType === 'numericColumn') {
      const f = type === 'int' ? parseInt(newValue, 10) : Number(newValue);
      return Number.isNaN(f) ? null : f;
    }
    if (type === 'boolean') {
      return isBoolean(newValue) ? newValue : newValue;
    } 
    if (type === 'string') {
      return trim(newValue);
    } 
    if (type === 'date') {
      const dateValue = newValue ? moment(newValue) : null;
      if (dateValue && dateValue.isValid()) {
        return dateValue.toDate();
      }
      return null;
    }
    if (type === 'picklist') {
      if (refData[newValue]) {
        return newValue;
      }
      return null;
    }
    return newValue;
  }

  columnValueGetter(params) {
    if (params.node.group) {
      // groupping
      return null;
    }
    const { columnData } = this.props;
    const { data, colDef: { cellRendererParams } } = params;

    const { column, customFieldType, isCustomMeta } = cellRendererParams;
    let keyField = null;
    if (customFieldType === CUSTOM_FIELD_TYPES.OPPORTUNITY) {
      keyField = 'opportunity_id';
    } else if (customFieldType === CUSTOM_FIELD_TYPES.ACCOUNT) {
      keyField = 'account_id';
    } else if (customFieldType === CUSTOM_FIELD_TYPES.USER) {
      keyField = 'user_id';
    }
    if (!keyField) {
      return null;
    }
    const id = data[keyField];
    if (!id) {
      return null;
    }
    if (columnData[id] === undefined || columnData[id] === null) {
      return null;
    }
    
    const vals = columnData[id][column._id] !== undefined ? columnData[id][column._id] : [];

    const objValues = isArray(vals) ? vals: [vals];
    if (isCustomMeta && objValues.length === 0) {
      // return default_value
      return column.default_value;
    }
    if (objValues.length === 1) {
      if (column.type === 'date') {
        const m = objValues[0] ? moment(objValues[0]) : null;
        return m && m.isValid() ? m.toDate() : null;
      }
      if (column.type === 'boolean') {
        return isBoolean(objValues[0]) ? objValues[0] : objValues[0] > 0;
      }
      
      return objValues[0];
    }
    return uniq(objValues);
  }

  columnCheckEditable(params) {
    const { colDef: { cellRendererParams } } = params;
    const { isCustomMeta } = cellRendererParams;
    return isCustomMeta;
  }

  columnCellRendererSelector(params) {
    if (!params) {
      return null;
    }
    return {
      component: 'customMetaFieldRenderer',
    };
  }

  columnDateKeyCreator(params) {
    const { value } = params;
    const m = value ? moment(value) : null;
    if (m && m.isValid()) {
      return m.startOf('day').format('X');
    }
    return '--';
  }

  columnBoolKeyCreator(params) {
    const { value } = params;
    let v = value;
    if (isNumber(value)) {
      v = value > 0;
    } else if (isBoolean(value)) {
      v = value;
    }
    if (isBoolean(v)) {
      return v ? 'YES' : 'NO';
    }
 
    return 'N/A';
  }

  columnPicklistKeyCreator(params) {
    const { value } = params;
    return value || 'N/A';
  }

  columnValueFormatter(params) {
    const { value } = params;
    if (value === '--') {
      return value;
    } else if (value) {
      return moment(`${params.value}`, 'X').format('MMM DD, YYYY');
    }
    return value;
  }

  createCustomFieldColumn(column, customFieldType, extraParams = {}) {
    const { type } = column;
    const isCustomMeta = column.target_custom_meta_id !== null && column.target_custom_meta_id !== undefined;
    let columnType = null;
    let enableRowGroup = false;
    let cellEditor = null;
    let cellEditorParams = null;
    let cellClass = null;
    let enableAutoHeight = false;
    let refData = null;
    let keyCreator = null;
    
    
    if (indexOf(['int', 'double', 'number', 'currency', 'percent'], type) >= 0) {
      columnType = 'numericColumn';
    } else if (indexOf(['date'], type) >= 0) {
      columnType = 'dateColumn';
    }
    /*
    if (indexOf(['int', 'date', 'boolean', 'picklist', 'multipicklist'], type) >= 0) {
      enableRowGroup = true;
    }
    */
    enableRowGroup = true; // https://github.com/lumen-software/TruSales/issues/1401

    if (indexOf(['string', 'picklist', 'multipicklist'], type) >= 0) {
      cellClass = 'cell-wrap-text';
      enableAutoHeight = true;
    }
    
    if (columnType === 'numericColumn') {
      cellEditor = 'agTextCellEditor';
    } else if (type === 'string') {
      cellEditor = 'agTextCellEditor';
    } else if (type === 'boolean') {
      cellEditor = 'checkboxCellEditor';
      keyCreator = this.columnBoolKeyCreator;
    } else if (type === 'date') {
      cellEditor = 'dateCellEditor';
      keyCreator = this.columnDateKeyCreator;
    } else if (type === 'picklist') {
      cellEditor = 'agRichSelectCellEditor';
      keyCreator = this.columnPicklistKeyCreator;
      cellEditorParams = {
        values: map(column.values, 'value'),
      };
      if (isCustomMeta) {
        refData = reduce(column.values, (vals, v) => {
          vals[v.value] = v.label;
          return vals;
        }, {});
      }
    }

    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: column.target_custom_meta_id,
      ...(cellClass ? { cellClass } : {}),
      cellRendererParams: {
        column,
        customFieldType,
        isCustomMeta,
        enableAutoHeight,
      },
      enableRowGroup,
      keyCreator,
      valueFormatter: type === 'date' ? this.columnValueFormatter : null,
      singleClickEdit: type === 'boolean',
      // suppressSorting: columnType !== 'numericColumn' && columnType !== 'dateColumn',
      suppressFilter: columnType === 'numericColumn' || columnType === 'dateColumn',
      type: columnType,
      cellEditor,
      cellEditorParams,
      editable: this.columnCheckEditable,
      valueGetter: this.columnValueGetter,
      valueSetter: this.columnValueSetter,
      valueParser: this.columnValueParser,
      cellRendererSelector: this.columnCellRendererSelector,
      refData,
      enableValue: columnType === 'numericColumn',
      allowedAggFuncs: columnType === 'numericColumn' ? ['sum', 'min', 'max', 'avg'] : [],
      autoHeight: enableAutoHeight && column.auto_height,
      ...extraParams,
    };
  }

  parseColumnDefs(columnDefs) {
    const { columnData } = this.props;
    return reduce(columnDefs, (columns, columnDef) => {
      if (columnDef.customFieldType !== undefined) {
        if (columnDef.column) {
          columns.push(this.createCustomFieldColumn(columnDef.column, columnDef.customFieldType, columnDef.params, columnData));
        }
      } else {
        columns.push(columnDef);
      }
      return columns;
    }, []);
  }

  saveColumns(columns) {
    const { id } = this.props;
    return new Promise((resolve, reject) => {
      this.saveTableStates(() => {
        const allPromises = reduce(columns, (items, column) => {
          const colId = column._id;
          const p = this.props.dispatch(updateTablePreferenceColumn(id, colId, column));
          items.push(p);
          return items;
        }, []);
        Promise.all(allPromises)
          .then(
            (results) => {
              this.restoreTableStates();
              resolve(results);
            },
            (errors) => {
              reject(errors);
            },
          )
      });
    });
  }

  handleSearch(query) {
    if (this.gridApi) {
      this.gridApi.setQuickFilter(query);
    }
  }

  handleDownload() {
    const { id, fileName, sheetName } = this.props;
    if (this.gridApi) {
      const params = {
        columnGroups: true,
        fileName: fileName || 'TruSales',
        sheetName: sheetName || id || 'TruSales',
        exportMode: 'xlsx',
      };
      this.gridApi.exportDataAsExcel(params);
    }
  }

  getAllRowData() {
    const rowData = [];
    if (this.gridApi) {
      this.gridApi.forEachNode((node) => {
        if (node.data) {
          rowData.push(node.data);
        }
      });
      return rowData;
    }
    return this.props.rowData;
  }

  getStatusBar() {
    if (this.props.hideStatusBar) {
      return null;
    }
    // Apply memorization to avoid re-creating the status bar config on render #3279
    if (!this.statusBar) {
      this.statusBar = {
        statusPanels: [
          {
            statusPanel: StatusRowComponent,
            align: 'left',
          },
          {
            statusPanel: 'agAggregationComponent',
            align: 'right',
          },
        ],
      };
    }
    return this.statusBar;
  }

  renderFullScreenButton() {
    const { enableFullScreen, id } = this.props;
    if (!enableFullScreen) {
      return null;
    }
    const { fullScreenMode } = this.state;
    const description = fullScreenMode ? 'Exit Full Screen' : 'Enter Full Screen';
    return (
      <OverlayTrigger placement={fullScreenMode ? 'bottom' : 'top'} overlay={<Tooltip id={`${id}-full-screen-tip`}>{description}</Tooltip>}>
        <Button bsStyle="link" onClick={this.toggleFullScreen}>
          <Fa name={fullScreenMode ? 'compress' : 'expand'} />
        </Button>
      </OverlayTrigger>
    );
  }
  renderDownloadButton() {
    const { enabledDownload, id } = this.props;
    const { fullScreenMode } = this.state;
    if (!enabledDownload || !this.gridApi) {
      return null;
    }
    return (
      <OverlayTrigger placement={fullScreenMode ? 'bottom' : 'top'} overlay={<Tooltip id={`${id}-download-tip`}>Export as Excel File</Tooltip>}>
        <Button bsStyle="link" onClick={this.handleDownload}>
          <Fa name="download" />
        </Button>
      </OverlayTrigger>
    );
  }

  renderTableConfig() {
    const { disableAddColumns } = this.props;
    if (disableAddColumns) {
      return null;
    }
    return (
      <AddColumnButton
        onClick={() => {
          this.requestEditColumn({
            is_visible: true,
          });
        }}
        gridApi={this.gridApi}
      >
        Add Column
      </AddColumnButton>
    );
  }

  renderContent() {
    const {
      rowData, sideBar,
      leftControls, rightControls,
      viewableDimensions,
      resourceType, fullScreenOffset,
      topControls,
    } = this.props;
    const {
      ready, fullScreenMode, navHeight, topControlHeight, isGrouping,
      groupIncludeFooter, groupIncludeTotalFooter,
    } = this.state;
    const { height } = viewableDimensions;

    const finalWidth = '100%';
    let finalHeight = fullScreenMode ? (height - navHeight - topControlHeight) : (height - topControlHeight);
    if (fullScreenMode && fullScreenOffset && fullScreenOffset.y) {
      finalHeight -= fullScreenOffset.y;
    }

    if (this.props.height) {
      finalHeight = this.props.height;
    }

    const items = ready ? rowData : [];
    const newSideBar = {
      ...sideBar,
      toolPanels: [
        {
          id: 'columns',
          labelDefault: 'Columns',
          labelKey: 'columns',
          iconKey: 'columns',
          toolPanel: 'agColumnsToolPanel',
          toolPanelParams: {
            suppressColumnFilter: true,
            suppressColumnSelectAll: true,
            suppressColumnExpandAll: true,
          },
        },
        ...(sideBar.toolPanels ? sideBar.toolPanels : []),
      ],
    };
    return (
      <div>
        <ColumnDataManager
          id={this.props.id}
          key={this.state.totalRows}
          getRowData={this.getAllRowData}
          resourceType={resourceType}
          onColumnLoaded={this.handleColumnDataLoaded}
          forceLoadSystemColumnTags={['lastSubmission', 'lastRequest']}
        />
        <nav className="navbar navbar-default navbar-controls">
          <form className="navbar-form navbar-left">
            <SearchField onSearch={this.handleSearch} />
            {leftControls}
          </form>
          <div className="navbar-form navbar-right">
            <div style={{ paddingRight: 15 }}>
              {rightControls}
              {this.renderTableConfig()}
              {this.renderDownloadButton()}
              {this.renderFullScreenButton()}
            </div>
          </div>
          <ReactResizeDetector handleHeight onResize={this.onResizeContainer} />
        </nav>
        {topControls !== null &&
          <div>
            {topControls}
            <ReactResizeDetector handleHeight onResize={this.onResizeTopController} />
          </div>
        }
        <div className="ag-theme-alpine" style={{ height: finalHeight, width: finalWidth, backgroundColor: '#ffffff' }} >
          <AgGridReact
            reactNext
            enableFilter
            enableColResize
            enableSorting
            animateRows
            enableRangeSelection
            suppressDragLeaveHidesColumns
            rowDragManaged
            suppressMakeColumnVisibleAfterUnGroup
            rowGroupPanelShow="onlyWhenGrouping"
            sheetName={this.props.tableName}
            
            rowHeight={34}
            {...this.props}
            getContextMenuItems={this.getContextMenuItems}
            columnDefs={this.parseColumnDefs(this.props.columnDefs)}
            defaultColDef={{
              resizable: true,
              filter: true,
              sortable: true,
              ...(this.props.defaultColDef),
            }}
            onGridReady={this.onGridReady}
            rowData={items}
            onColumnVisible={this.onColumnVisible}
            onColumnResized={this.onColumnResized}
            onColumnMoved={this.onColumnMoved}
            onRowDataUpdated={() => {
              this.setState({ totalRows: this.getAllRowData().length });
            }}
            sideBar={newSideBar}

            groupIncludeFooter={(groupIncludeFooter && isGrouping)}
            groupIncludeTotalFooter={(groupIncludeTotalFooter && isGrouping)}
            // Untested groupIncludeFooter and groupIncludeTotalFooter replacements
            // groupTotalRow={groupIncludeFooter && isGrouping && 'bottom'}
            // grandTotalRow={groupIncludeTotalFooter && isGrouping && 'bottom'}

            getMainMenuItems={this.getMainMenuItems}
            onColumnRowGroupChanged={this.onColumnRowGroupChanged}
            statusBar={this.getStatusBar()}
            components={{
              requestedFeedbackRenderer: RequestedFeedbackRenderer,
              agTotalRowCountComponent: StatusRowComponent,
              agColumnHeader: CustomHeader,
              customFieldRenderer: CustomFieldRenderer,
              customMetaFieldRenderer: CustomMetaFieldRenderer,
              checkboxCellEditor: CheckboxCellEditor,
              dateCellEditor: DateCellEditor,
              ...this.props.frameworkComponents,
            }}
          />
        </div>
      </div>
    );
  }

  render() {
    const { fullScreenMode } = this.state;
    const { fullScreenOffset } = this.props;
    return (
      <div ref={(el) => { this._el = el; }}>
        <Veil
          anchorElement={this._el}
          fullScreenMode={fullScreenMode}
          fullScreenOffset={fullScreenOffset}
        >
          {this.renderContent()}
        </Veil>
        <DeleteColumnModal />
        <ResetColumnsModal />
        <EditColumnModal {...this.props.tableManageConfigs} />
      </div>
    );
  }
}


GodTable.propTypes = {
  dispatch: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  onGridReady: PropTypes.func,
  tableState: PropTypes.shape({}),
  onColumnVisible: PropTypes.func,
  onColumnResized: PropTypes.func,
  onColumnMoved: PropTypes.func,
  custommetaManagerOptions: PropTypes.shape({}),
  columnData: PropTypes.shape({}),
  tableName: PropTypes.string,
  frameworkComponents: PropTypes.shape({}),
  sideBar: PropTypes.shape({}),
  rowData: PropTypes.arrayOf(PropTypes.shape({})),
  columnDefs: PropTypes.arrayOf(PropTypes.shape({})),
  leftControls: PropTypes.node,
  rightControls: PropTypes.node,
  topControls: PropTypes.node,
  enableFullScreen: PropTypes.bool,
  onExitFullScreen: PropTypes.func,
  onEnterFullScreen: PropTypes.func,
  getMainMenuItems: PropTypes.func,
  viewableDimensions: PropTypes.shape({
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
  }).isRequired,
  defaultColDef: PropTypes.shape({}),
  windowWidth: PropTypes.number,
  windowHeight: PropTypes.number,
  tableManageConfigs: PropTypes.shape({}),
  siteHeaderHeight: PropTypes.number.isRequired,
  siteFooterHeight: PropTypes.number.isRequired,
  fullScreenMode: PropTypes.bool,
  resourceType: PropTypes.string,
  auth: PropTypes.shape({
    _id: PropTypes.string,
  }),
  organization: PropTypes.shape({
    _id: PropTypes.string,
  }),
  onColumnRowGroupChanged: PropTypes.func,
  fullScreenOffset: PropTypes.shape({
    y: PropTypes.number,
  }),
  enabledDownload: PropTypes.bool,
  fileName: PropTypes.string,
  sheetName: PropTypes.string,
  context: PropTypes.shape({}),
  disableAddColumns: PropTypes.bool,
  height: PropTypes.number,
  hideStatusBar: PropTypes.bool,
};
GodTable.defaultProps = {
  onGridReady: () => {},
  tableState: null,
  tableName: null,
  defaultColDef: {},
  onColumnVisible: () => {},
  onColumnResized: () => {},
  onColumnMoved: () => {},
  getMainMenuItems: null,
  custommetaManagerOptions: {},
  columnData: {},
  frameworkComponents: {},
  columnDefs: [],
  sideBar: {},
  rowData: [],
  leftControls: null,
  rightControls: null,
  topControls: null,
  enableFullScreen: false,
  onExitFullScreen: () => {},
  onEnterFullScreen: () => {},
  windowWidth: 0,
  windowHeight: 0,
  tableManageConfigs: {},
  onColumnRowGroupChanged: () => {},
  fullScreenMode: false,
  resourceType: null,
  auth: {
    _id: null,
  },
  organization: {
    _id: null,
  },
  fullScreenOffset: {
    y: 0,
  },
  enabledDownload: true,
  fileName: typeof document !== 'undefined' ? document.title : 'TruSales',
  sheetName: typeof document !== 'undefined' ? document.title : 'TruSales',
  context: null,
  disableAddColumns: false,
  height: null,
  hideStatusBar: false,
};

GodTable.contextTypes = {
  updateUserPreference: PropTypes.func.isRequired,
  userPreferences: PropTypes.object.isRequired,
};

function mapStateToProps(state, ownProps) {
  const auth = getUser(state);
  const organization = getUserCurrentOrganization(state);
  return {
    auth,
    organization,
    tableState: getTableStates(state, organization ? organization._id : null, auth ? auth._id : null, ownProps.id),
    columnData: getColumnData(state),
    viewableDimensions: getViewableDimensions(state),
    windowWidth: getWindowWidth(state),
    windowHeight: getWindowHeight(state),
    siteHeaderHeight: getHeaderHeight(state),
    siteFooterHeight: getFooterHeight(state),

  };
}

GodTable.RESOURCE_TYPE = ColumnDataManager.RESOURCE_TYPE;
export default connect(mapStateToProps)(GodTable);
